<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
    <ng-container *ngIf="showBarrierSelection">
        <div [formGroup]="formGroup" class="no-field-space">
            <sc-flex>
                <sc-checkbox-field formControlName="bookEntrance"
                    label="{{'book entrance' | translate: ['tmc-yard.control.cep.action.book-entrance', translationService.language]}}"></sc-checkbox-field>
                <sc-dictionary-label [dictionaryKey]=""></sc-dictionary-label>
                <sc-content-spacer></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{'Entrance' | translate: ['tmc-yard.control.cep.label.entrance',
                        translationService.language]}}</mat-label>
                    <mat-select name="entrance" formControlName="entrance">
                        <mat-option *ngFor="let o of entrances" [value]="o">
                            {{o.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </sc-flex>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
    </ng-container>
    <sc-flex-fitting-content [vertical]="true">
        <sc-loading-spinner [isLoading]="isLoading">
            <div class="grid">
                <app-cep-camera-tile class="camera-tile" *ngIf="cameraUrl" [url]="cameraUrl"></app-cep-camera-tile>
                <app-cep-profile-tile *ngFor="let profile of profiles" [profile]="profile"
                    (click)="handleProfileClick(profile);"></app-cep-profile-tile>
            </div>
        </sc-loading-spinner>
    </sc-flex-fitting-content>
</sc-flex>
